module.exports = __webpack_public_path__ + "img/zep2.4ddec2cd.jpg";